<template>
  <div class="container py-5 text-center" style="height:55vh; margin-top: 7.5rem;">
      <h1 class="font-weight-normal pt-5">{{ lang == 'es' ? 'Esta página no está disponible' : 'This page is not available' }}</h1>
      <h5 class="font-weight-normal">{{ lang == 'es' ? 'Es posible que el enlace que has seguido sea incorrecto o que se haya eliminado la página.' : 'The link you followed may be incorrect or the page may have been deleted.' }}</h5>
      <router-link to="/" class="h5 font-weight-normal d-block text-muted">{{ lang == 'es' ? 'volver al principio' : 'back to index' }}</router-link>
  </div>
</template>
<script>
export default {
  data(){
    return{
      lang: window.lang
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/notfound.vue